export const ENVIRONMENTAL_AGREEMENT_STATES_DRAFT = 961700000
export const ENVIRONMENTAL_AGREEMENT_STATES_AWAITING_SIGNATURE = 961700003
export const ENVIRONMENTAL_AGREEMENT_STATES_SIGNED = 1
